@if (form) {
  <div [formGroup]="form">
    <div class="row">
      @if (form.value.identifier) {
        <div class="form-group col-lg">
          <label>{{'administration.sectionsManagement.code' | translate}}</label>
          <apc-form-input [disabled]="true" [class]="'form-control autogenerated'" formControlName="code"
            type="text">
          </apc-form-input>
        </div>
      }
      <div class="form-group col-lg">
        <label>{{'administration.sectionsManagement.value' | translate}} *</label>
        <apc-form-input [class]="'form-control'" formControlName="name" type="text"></apc-form-input>
      </div>
    </div>
    <div class="row mt-3">
      <div class="form-group col-lg">
        <apc-ui-switch formControlName="allowEmptyBudgets">
          <span label>{{'administration.sectionsManagement.allowEmptyBudgets' | translate}}</span>
        </apc-ui-switch>
      </div>
      <div class="form-group col-lg-6">
        <apc-ui-switch formControlName="projectManagerRequired">
          <span label>{{'administration.sectionsManagement.projectManagerRequired' | translate}}</span>
        </apc-ui-switch>
      </div>
    </div>
    <div class="row mt-3">
      <div class="form-group col-lg">
        <label>{{'administration.sectionsManagement.group1' | translate}}</label>
        <apc-form-input [class]="'form-control'" type="text" formControlName="group1">
        </apc-form-input>
      </div>
      <div class="form-group col-lg">
        <label>{{'administration.sectionsManagement.group2' | translate}}</label>
        <apc-form-input [class]="'form-control'" type="text" formControlName="group2">
        </apc-form-input>
      </div>
    </div>
    <div class="row mt-3">
      <div class="form-group col-lg">
        <label>{{'administration.sectionsManagement.group3' | translate}}</label>
        <apc-form-input [class]="'form-control'" type="text" formControlName="group3">
        </apc-form-input>
      </div>
      <div class="form-group col-lg">
        <label>{{'administration.sectionsManagement.group4' | translate}}</label>
        <apc-form-input [class]="'form-control'" type="text" formControlName="group4">
        </apc-form-input>
      </div>
    </div>
    <div class="row mt-3">
      <div class="form-group col-lg-6">
        <label>{{'administration.sectionsManagement.group5' | translate}}</label>
        <apc-form-input [class]="'form-control'"type="text" formControlName="group5">
        </apc-form-input>
      </div>
    </div>
    <div class="row mt-3">
      <div class="form-group col-lg">
        <label>{{'administration.sectionsManagement.description' | translate}}</label>
        <apc-form-input [class]="'form-control'" formControlName="description" type="textarea" rows="4"></apc-form-input>
      </div>
    </div>
  </div>
}